import React from "react";
import { Hospital, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { AUTH } from "@/constants/testIds";
import { initials } from "@/lib/initials";

function Brand() {
  return (
    <div className="flex items-center gap-3">
      <div className="w-8 h-8 rounded-md bg-orange-600 text-white flex items-center justify-center">
        <Hospital className="w-4 h-4" strokeWidth={1.75} />
      </div>
      <div className="leading-tight">
        <div className="text-sm font-semibold tracking-tight">Signature Manager</div>
        <div className="text-[11px] text-slate-500">Microsoft 365 · Hospital Pediátrico</div>
      </div>
    </div>
  );
}

export function TopBar({ user, onLogout }) {
  return (
    <header className="sticky top-0 z-40 h-14 bg-white border-b border-slate-200 flex items-center px-6 justify-between">
      <Brand />
      <div className="flex items-center gap-3">
        <span className="hidden md:inline text-xs text-slate-500 uppercase tracking-wider">
          {user?.role?.replace("_", " ")}
        </span>
        <Avatar className="h-8 w-8">
          <AvatarFallback className="bg-orange-100 text-orange-700 text-xs font-semibold">
            {initials(user?.display_name || user?.email, "A")}
          </AvatarFallback>
        </Avatar>
        <Button variant="ghost" size="sm" onClick={onLogout} data-testid={AUTH.logoutBtn}
          className="text-slate-600 hover:text-orange-700 hover:bg-orange-50">
          <LogOut className="w-4 h-4 mr-1.5" strokeWidth={1.75} />
          Salir
        </Button>
      </div>
    </header>
  );
}
